export default __webpack_public_path__ + "static/media/new-Boards2.1287e848.jpg";